import React from 'react';
import './Block.scss';

export const Block = (props) => {
  const { title, desc, line, children } = props;
  return (
    <div className='block'>
      {(!!title || !!desc) && (
        <div className='block-header'>
          {!!title && <div className='title'>{title}</div>}
          {!!desc && (
            <div className='desc'>
              {typeof desc === 'string' && desc}
              {Array.isArray(desc) && desc?.map(([key, val] = [], index) => (
                <div key={index} className='desc-row'>
                  <div className='desc-key'>{key}</div>
                  <div className='desc-val'>{val}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      {!!line && <div className='line-spacing' />}
      <div className='content'>
        {children}
      </div>
    </div>
  );
};
